import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private langChangeSubscription: Subscription;

  constructor(private _translateService: TranslateService) {
    super();

    this.getAndInitTranslations();

    this.langChangeSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.getAndInitTranslations();
        this.changes.next();
      }
    );
  }

  getAndInitTranslations() {
    this.firstPageLabel = this._translateService.instant(
      'TABLE.PAGINATION.FIRSTPAGE'
    );
    this.previousPageLabel = this._translateService.instant(
      'TABLE.PAGINATION.PREVIOUSPAGE'
    );
    this.nextPageLabel = this._translateService.instant(
      'TABLE.PAGINATION.NEXTPAGE'
    );
    this.lastPageLabel = this._translateService.instant(
      'TABLE.PAGINATION.LASTPAGE'
    );
    this.itemsPerPageLabel = this._translateService.instant(
      'TABLE.PAGINATION.ITEMS_PER_PAGE'
    );

    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      const start = page * pageSize + 1;
      const end =
        (page + 1) * pageSize > length ? length : (page + 1) * pageSize;
      return `${start} - ${end} ${this._translateService.instant('TABLE.PAGINATION.OF')} ${length}`;
    };
  }
}
